import { AppThunk } from '../../../store/rootReducer';
import { annotationTaskIdSelector } from '../../ecg/selectors/annotation-task.selectors';
import {
  ecgIdSelector,
  roundedDurationSelector,
} from '../../ecg/selectors/ecg.selectors';
import { leadCountSelector } from '../../ecg/selectors/signal.selectors';
import { hasILRImageSelector } from '../../layout/selectors/layout.selectors';
import { rawSignalLeadNamesSelector } from '../../raw-signal/selectors/raw-signal.selectors';
import { PageName } from '../types/analytics.types';
import { sendPage } from '../analytics.utils';
import { userSelector } from '../../auth/selectors/auth.selectors';

export const sendAnalyticsPage =
  (page: PageName, sendPageFn = sendPage): AppThunk =>
  (_, getState) => {
    const ecgId = ecgIdSelector(getState());
    const user = userSelector(getState());
    const nbLeads = leadCountSelector(getState());
    const ecgDuration = Math.floor(roundedDurationSelector(getState()) / 1000);
    const annotationTaskId =
      annotationTaskIdSelector(getState()) ?? 'NOT_AN_ANNOTATION_TASK';
    const hasIlr = hasILRImageSelector(getState());
    const hasRaw = rawSignalLeadNamesSelector(getState()).length !== 0;

    if (ecgId == null || user == null) {
      return null;
    }

    sendPageFn({
      page,
      properties: {
        user_id: user.id,
        ecg_id: ecgId,
        nb_leads: nbLeads,
        ecg_duration_s: ecgDuration,
        annotation_task_id: annotationTaskId,
        has_ilr: hasIlr,
        has_raw: hasRaw,
      },
    });
  };
